import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';
import { FileBeforeUploadEvent, FileSelectEvent, FileUploadEvent, FileUploadHandlerEvent, FileUploadModule, UploadEvent } from 'primeng/fileupload';
import { ProgressBarModule } from 'primeng/progressbar';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-documentation',
    standalone: true,
    imports: [CommonModule, SharedModule, TranslateModule, FileUploadModule, ProgressBarModule],
    templateUrl: './documentation.component.html',
    styleUrl: './documentation.component.scss',
})
export class DocumentationComponent {

	private appData = inject(AppService);

    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    documentationTitle = 'features.documentation.documentationTitle';
    documentationSubtitle = 'features.documentation.documentationSubtitle';

    documentationBank = 'features.documentation.documentationBank';
    docBankBox = 'features.documentation.docBankBox';
    docBankInfo = 'features.documentation.docBankInfo';

    documentationWorth = 'features.documentation.documentationWorth';
    docWorthBox = 'features.documentation.docWorthBox';
    docWorthInfo = 'features.documentation.docWorthInfo';

    docSideSteps = 'features.documentation.docSideSteps';
    docSideStep1 = 'features.documentation.docSideStep1';
    docSideStep2 = 'features.documentation.docSideStep2';
    docSideTime = 'features.documentation.docSideTime';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    files = [''];

    times = 0;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private saveDataService: SaveDataService,
        private changeStepService: ChangeStepService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(25);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        // this.changeDeviceService.changedDevice.subscribe(value => {this.isPortraitDevice = value});

        this.createForm();
        this.setValuesForm(this.appData.data.userData);

        //this.formIsValid();
    }

    createForm() {
        this.formGroup = this.fb.group({
            upload1: new FormControl (''),
            upload2: new FormControl (''),
        });
    }

    setValuesForm(value?:any) {
       if(value != undefined) {
        this.formGroup = this.fb.group({
            upload1: new FormControl(value.upload1 ? value.upload1 : ''),
            upload2: new FormControl(value.upload2 ? value.upload2s : ''),
        });
      }
    }

    //-------------------------//
    //------EVENT METHODS------//

    onSelect(event: FileSelectEvent) {
        if (this.times >= 1)
            this.formIsValid();
        else
            this.times++;
    }

    //-------------------------//

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.createForm();
        this.saveDataService.saveDataLocal(this.formGroup.value, 'documentation');
        //this.router.navigate(['/main/co-holder'], { relativeTo: this.route });
        this.router.navigate(['/main/step/authentications/authentication-data'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'documentation');
        this.router.navigate(['/main/step/documentation'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
